import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  AppBar,
  Toolbar,
  IconButton,
  Stack,
  Chip,
  List,
  Button,
  Divider,
  Dialog,
  DialogContent,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { parseISO, format } from "date-fns";
import { AuthContext } from "../context/AuthContext";
import { CITIES } from "../data/CITIES";
import getCoupons from "../api/coupon/getCoupons";
import getRewardCards from "../api/rewardcard/getRewardCards";
import zhTW from "date-fns/locale/zh-TW";
import buyCoupon from "../api/user/buyCoupon";
import ConfirmDialog from "../component/ConfirmDialog";
import starIcon from "../icons/page_star.png";
import backIcon from "../icons/page_back.png";
import pointIcon from "../icons/point.png";
const RewardCardPage = () => {
  const [rewardCards, setRewardCards] = useState([]);
  const [cities, setCities] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [showPoints, setShowPoints] = useState(0);
  const [cardCount, setCardCount] = useState(0);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [selectedButton, setSelectedButton] = useState(null);
  const [msgDialogOpen, setMsgDialogOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const userContext = useContext(AuthContext);
  const maxAvatars = 10; // Max avatars to display

  useEffect(() => {
    async function fetchRewardCards() {
      try {
        const response = await getRewardCards();

        if (response.RewardCards !== null && response.Code === "000") {
          setRewardCards(response.RewardCards);
        }
      } catch (error) {
        console.error("Failed to fetch coupons", error);
      }
    }

    const fetchCoupons = async () => {
      try {
        const response = await getCoupons();
        let coupons = [];

        if (response.Coupons)
          coupons = response.Coupons.filter(
            (coupon) =>
              coupon.IsValid &&
              coupon.CanBeSold &&
              new Date() < new Date(coupon.EndDate)
          );
        setCoupons(coupons);
      } catch (err) {
        console.error(err.message);
      }
    };

    if (coupons) {
      fetchCoupons();
    }

    if (userContext.user !== null) fetchRewardCards();
  }, []);

  useEffect(() => {
    let tmpCity = {};
    let cityArray = [];

    for (var key in rewardCards) {
      if(rewardCards[key].City!=="桃園縣"){
        tmpCity[rewardCards[key].City] = 1;
      }

    }
    for (key in tmpCity) {

      cityArray.push(key);
    }

    cityArray.sort((a, b) => {
      return CITIES.indexOf(a) - CITIES.indexOf(b);
    });
    let rewardCardIndex = rewardCards.findIndex(
      (card) => card.City === selectedButton
    );
    if (!isNaN(Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars))) {
      setCardCount(
        Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars)
      );
    }

    if (!isNaN(rewardCards[rewardCardIndex]?.Points % maxAvatars)) {
      setShowPoints(rewardCards[rewardCardIndex]?.Points % maxAvatars);
    }
    setCities(cityArray);

    if (!selectedButton) setSelectedButton(cityArray[0]);
  }, [rewardCards]);
  useEffect(() => {
    let rewardCardIndex = rewardCards.findIndex(
      (card) => card.City === selectedButton
    );
    if (!isNaN(Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars))) {
      setCardCount(
        Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars)
      );
    }

    if (!isNaN(rewardCards[rewardCardIndex]?.Points % maxAvatars)) {
      setShowPoints(rewardCards[rewardCardIndex]?.Points % maxAvatars);
    }
  }, [selectedButton]);

  const buyCoupounClick = (coupon) => {
    const cityIndex = rewardCards.findIndex(
      (card) => card.City === selectedButton
    );

    const callBuyCoupons = async () => {
      try {
        const response = await buyCoupon(coupon.Id, selectedButton);
        fetchRewardCards();
      } catch (err) {
        console.error(err.message);
      }
    };
    async function fetchRewardCards() {
      try {
        const response = await getRewardCards();

        if (response.RewardCards !== null && response.Code === "000") {
          setRewardCards(response.RewardCards);
        }
      } catch (error) {
        console.error("Failed to rewardCard", error);
      }
    }
    if (rewardCards[cityIndex]?.Points >= coupon.Points) {
      callBuyCoupons();
    }
  };

  const parsedDate = (inputDateString) => {
    const date = parseISO(inputDateString, "dd-MM-yyyy HH:mm", new Date());
    const formattedDate = format(date, "yyyy/MM/dd HH:mm");

    return formattedDate;
  };

  const RewardCard = () => {
    let rewardCardIndex = rewardCards.findIndex(
      (card) => card.City === selectedButton
    );

    return (
      <Card sx={{ bgcolor: theme.palette.primary.main, maxWidth: "370px",borderRadius:3,marginTop:1 }}>
        <CardContent>
          <Typography
            align="center"
            variant="h5"
            fontWeight={"bold"}
            color={theme.palette.text.primary}
            component="div"
          >
            集點卡
          </Typography>
          <Grid
            container
            spacing={2}
            marginTop={1}
            alignItems="center"
            justifyContent="center"
          >
            {Array.from({ length: maxAvatars }).map((_, index) => (
              <Grid key={index} style={{ width: "20%" }}>
                <Avatar
                  src={
                    isNaN(rewardCards[rewardCardIndex]?.Points) ||
                    rewardCards[rewardCardIndex]?.Points === 0
                      ? null
                      : showPoints === 0
                      ? pointIcon
                      : index < showPoints
                      ? pointIcon
                      : null
                  }
                  sx={{
                    background:"#d9d9d9",
                    width: 56,
                    height: 56,
                  }}
                >
                  {""}
                </Avatar>
              </Grid>
            ))}
          </Grid>
        </CardContent>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          color={theme.palette.text.primary}
          marginX={1}
        >
          <Typography color={theme.palette.text.primary}>{`限${
            rewardCards[rewardCardIndex]?.City || ""
          }`}</Typography>
          <Typography color={theme.palette.text.primary}>
            {cardCount === 0 ? `第1張` : `第${cardCount}張`}
          </Typography>

          <Typography color={theme.palette.text.primary}>{`共${
            rewardCards[rewardCardIndex]?.Points || 0
          }點`}</Typography>
        </Stack>
      </Card>
    );
  };

  const handleBackButtonClick = () => {
    navigate("/app");
  };
  return (
    <Box
      width="100%"
      height="100vh"
      sx={{ backgroundColor: theme.palette.background.default }}
    >
           <AppBar           sx={{ bgcolor: theme.palette.appBar }}
          position="sticky"
          color="secondary">
        <Toolbar  sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <Box
              component="img"
              src={backIcon}
              alt="back"
              sx={{ width: "50px", marginLeft: "-16px" }}
              onClick={handleBackButtonClick}
            />
          <Typography
              align="center"
              sx={{
                fontWeight: "bold",
                fontSize: "h6.fontSize",
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
          >集點卡</Typography>
        </Toolbar>
      </AppBar>
      {userContext.user === null ? (
        <Typography
          marginTop={20}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
          align="center"
        >
          尚未登入
        </Typography>
      ) : (
        <Box>
          {cities.map((label, index) => (
            <Button
              key={"cities" + index}
              // Set the variant based on the selected state
              variant={selectedButton === label ? "contained" : "contained"}
              // Set the click handler to update the selected button
              onClick={() => setSelectedButton(label)}
              sx={{
                maxWidth: "25%",
                margin: "1px",
                fontSize: "12pt",
                fontWeight: "bold",
                background:
                  selectedButton === label
                    ? theme.palette.selected
                    : theme.palette.primary.main,

                borderRadius: 5,
                zIndex: 1,
                color:
                  selectedButton === label
                    ? theme.palette.text.selected
                    : theme.palette.text.blue,
                "&:before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  zIndex: -1,
                  borderRadius: "inherit",
                  padding: "2.5px",
                  background: theme.palette.selected,
                  WebkitMask: ` 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0)`,
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                },
                "&:focus": {
                  backgroundColor: theme.palette.selected,
                  color: theme.palette.text.selected,
                },
              }}
            >
              {label}
            </Button>
          ))}
          <Box
            marginTop={1}
            marginBottom={2}
            justifyContent={"center"}
            display={"flex"}
          >
            <RewardCard />
          </Box>

          {coupons.map((coupon, index) => (
            <React.Fragment key={index}>
              <Card sx={{ marginX: 1 }}>
                <CardContent>
                  <Stack
                    direction={"row"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Box>
                      <Stack direction={"row"} alignItems={"center"}>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          fontSize={22}
                          fontWeight={"bold"}
                        >
                          {coupon.Name}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Box color={theme.palette.text.secondary} display={'flex'} alignItems={'self-end'}>
                          <Box
                            component="img"
                            src={starIcon}
                            sx={{ width: "20px", height: "20px"}}
                          />
                            {coupon.ValidDays > 0
                            ? `兌換後可用${coupon.ValidDays}天`
                            : `使用期限:${format(
                                new Date(coupon.StartDate),
                                "yyyy/MM/dd",
                                { locale: zhTW }
                              )}~${format(
                                new Date(coupon.EndDate),
                                "yyyy/MM/dd",
                                {
                                  locale: zhTW,
                                }
                              )}`}
                          
                        </Box>

                        <Typography
                          color={theme.palette.text.secondary}

                        >
                        {coupon.Description}
                        </Typography>
                      </Stack>
                    </Box>

                    <Button
                      disabled={
                        rewardCards[
                          rewardCards.findIndex(
                            (card) => card.City === selectedButton
                          )
                        ]?.Points < coupon.Points
                      }
                      sx={{
     
                        borderRadius: 3,
                        width: "30%",
                        height:"5vh",
                        background: theme.palette.selected,
                        color: "white",
                        fontSize:"12pt",
                        alignItems: "center", // Vertically centers the text
                        justifyContent: "center", // Horizontally centers the text
                        "&:focus": {
                          bgcolor: "gray",
                        },
                        "&:disabled": {
                          color:theme.palette.text.selected,
                          background: theme.gradients.secondary,
                        },
                      }}
                      variant="outlined"
                      color="info"
                      onClick={() => {
                        setSelectedCoupon(coupon);
                        setMsgDialogOpen(true);
                      }}
                    >
                      {rewardCards[
                        rewardCards.findIndex(
                          (card) => card.City === selectedButton
                        )
                      ]?.Points >= coupon.Points
                        ? `${coupon.Points}點兌換`
                        : "點數不足"}
                    </Button>
                  </Stack>
                </CardContent>
              </Card>

              <Divider variant="inset" />
            </React.Fragment>
          ))}
        </Box>
      )}
      <ConfirmDialog
        open={msgDialogOpen}
        onConfirm={() => {
          buyCoupounClick(selectedCoupon);
        }}
        title={"兌換優惠券"}
        content={"是否兌換優惠券"}
        onClose={() => {
          setMsgDialogOpen(false);
        }}
      ></ConfirmDialog>
    </Box>
  );
};

export default RewardCardPage;
